import styled from 'styled-components';
import { Row, Col, Button } from 'react-bootstrap';

export const PaddedRow = styled(Row)`
    margin: 20px 0 20px 0;
`;

export const CenteredCol = styled(Col)`
	margin: 0;
	padding: 0;
	text-align: center;
`;

export const LeftAlignedCol = styled(Col)`
	margin: 0;
	padding: 0;
`;

export const RighAlignedCol = styled(Col)`
	margin: 0;
	padding: 0;
	text-align: right;
`;

export const StyledButton = styled(Button)`
	outline: 0;
	border-color: white;
	color: white;
	border-width: 2px;
	background-color: transparent;
	border-radius:0;
	white-space: normal;

	&:focus {
		border-color: white;
        background-color: transparent;
        color: white;
        box-shadow: 0 0 0 3px orange;
	}

	&:hover {
		outline: 0;
		color: black;
		background-color: white;
		border-color: gray;
		cursor: pointer;
	}

	// NOTE: Must add !important for every style in active otherwise it fails to override bootstrap's default active style!
	&&&:active {
		outline: 0;
		border-color: gray;
		background-color: white;
		color: orange;
	}
`;

export const DayNightButton = styled(StyledButton)`

	color: white;

    &:focus {
        border-color: white;
        background-color: transparent;
        color: white;
        box-shadow: 0 0 0 3px orange;
    }

    &:hover {
        color: black;
        border-color: ${props => props.isDay ? '#2975a4' : 'gray'};
        background-color: ${props => props.isDay ? '#b3edff' : 'lightgray'};

        small {
            color: orange;
        }
    }

    // NOTE: Must add &&& (instead of !important) for every style in active otherwise it fails to override bootstrap's default active style!
    &&&:active {
        color: black;
        background-color: ${props => props.isDay ? '#00a5d9' : 'lightlightgray'};
        border-color: ${props => props.isDay ? '#2975a4' : 'gray'};

        small {
            color: orange;
        }
    }
`;

export const TimeMark = styled.small`
    color: yellow;
`;


// WEBPACK FOOTER //
// ./src/components/StyledPrimitives/StyledPrimitives.js